module.exports = __webpack_public_path__ + "img/blog-770x420.ad26784c.jpg";